import { collectionProductFragment } from './get-collection-products-query'
import { metafieldFragment } from './utils'

export const getCustomerFavoritesQuery = /* GraphQL */ `
	query getCustomerFavorites($customerAccessToken: String!) {
		customer(customerAccessToken: $customerAccessToken) {
			id
			email

			favorites: metafield(namespace: "my_fields", key: "favorites") {
				id
				value
			}
		}
	}
`

export const getCustomerFavoritesWithDetailsQuery = /* GraphQL */ `
	query getCustomerFavoritesWithDetails($ids: [ID!]!) {
		nodes(ids: $ids) {
			... on Product {
				...collectionProduct
			}
		}
	}

	${metafieldFragment}
	${collectionProductFragment}
`
